import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "regularHidden",
    "schemaHidden",
    "select",
    "selected",
    "newInput",
    "regularGroup",
    "schemaGroup",
  ]

  connect() {
    // Ensure hidden values match initial rendered chips.
    this._syncHiddenFromChips()
  }

  addFromSelect(event) {
    const value = event?.target?.value
    if (!value) return
    const opt = event.target.selectedOptions?.[0]
    const kind = opt?.dataset?.kind || "regular"
    this._addLabel(value, kind)
    event.target.value = ""
  }

  addNew(event) {
    event?.preventDefault?.()
    if (!this.hasNewInputTarget) return
    const value = this.newInputTarget.value
    if (!value) return
    this._addLabel(value, "regular")
    this.newInputTarget.value = ""
  }

  remove(event) {
    event?.preventDefault?.()
    const btn = event.target.closest("[data-remove-label]")
    if (!btn) return
    const label = btn.getAttribute("data-remove-label") || ""
    const norm = this._normalize(label)

    let removedKind = "regular"
    this.selectedTarget.querySelectorAll("[data-tag-label]").forEach((chip) => {
      if (this._normalize(chip.getAttribute("data-tag-label")) === norm) {
        removedKind = chip.getAttribute("data-tag-kind") || removedKind
        chip.remove()
      }
    })

    // Put it back in the dropdown if we have one.
    if (this.hasSelectTarget) {
      this._ensureOption(label, removedKind)
    }

    this._syncHiddenFromChips()
  }

  _addLabel(label, kind) {
    const norm = this._normalize(label)
    if (!norm) return

    // Already selected?
    const exists = Array.from(this.selectedTarget.querySelectorAll("[data-tag-label]")).some((chip) => {
      return this._normalize(chip.getAttribute("data-tag-label")) === norm
    })
    if (exists) return

    // Remove from dropdown if present.
    if (this.hasSelectTarget) {
      const opt = Array.from(this.selectTarget.options).find((o) => this._normalize(o.value) === norm)
      if (opt) opt.remove()
    }

    // Create a new chip.
    const chip = document.createElement("span")
    chip.className = "badge bg-body-tertiary border border-secondary-subtle text-body d-inline-flex align-items-center gap-1 me-1 mb-1"
    chip.setAttribute("data-tag-label", label.trim())
    chip.setAttribute("data-tag-kind", kind || "regular")
    chip.innerHTML = `
      <span>${this._escapeHtml(label.trim())}</span>
      <button type="button" class="btn-close btn-close-sm ms-1" aria-label="Remove" data-remove-label="${this._escapeAttr(label.trim())}"></button>
    `
    chip.querySelector("button")?.addEventListener("click", (e) => this.remove(e))
    this.selectedTarget.appendChild(chip)

    this._syncHiddenFromChips()
  }

  _syncHiddenFromChips() {
    const chips = Array.from(this.selectedTarget.querySelectorAll("[data-tag-label]"))
    const regular = []
    const schema = []

    chips.forEach((el) => {
      const label = (el.getAttribute("data-tag-label") || "").trim()
      if (!label) return
      const kind = (el.getAttribute("data-tag-kind") || "regular").toString()
      if (kind === "schema") schema.push(label)
      else regular.push(label)
    })

    if (this.hasRegularHiddenTarget) this.regularHiddenTarget.value = regular.join(", ")
    if (this.hasSchemaHiddenTarget) this.schemaHiddenTarget.value = schema.join(", ")
  }

  _ensureOption(label, kind) {
    const norm = this._normalize(label)
    const exists = Array.from(this.selectTarget.options).some((o) => this._normalize(o.value) === norm)
    if (exists) return

    const opt = document.createElement("option")
    opt.value = label.trim()
    opt.textContent = label.trim()
    opt.dataset.kind = kind || "regular"

    const k = (kind || "regular").toString()
    if (k === "schema" && this.hasSchemaGroupTarget) {
      this.schemaGroupTarget.appendChild(opt)
    } else if (k === "regular" && this.hasRegularGroupTarget) {
      this.regularGroupTarget.appendChild(opt)
    } else {
      this.selectTarget.appendChild(opt)
    }
  }

  _normalize(value) {
    return (value || "").toString().trim().toLowerCase()
  }

  _escapeHtml(text) {
    return (text || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;")
  }

  _escapeAttr(text) {
    // Same escaping is fine for attribute usage in this context.
    return this._escapeHtml(text)
  }
}


